"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_ZHTW_TRANS = {
    'time picker': '時間',
    'today': '今天',
    'set time': '設置時間',
    'close': '關閉',
    'confirm': '確認',
    'hour': '時',
    'minute': '分',
    'second': '秒',
};
//# sourceMappingURL=zh-tw.js.map


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/ng2-date-time-picker/locale/zh-tw.js
// module id = ../../../../ng2-date-time-picker/locale/zh-tw.js
// module chunks = 4